import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=68a71da0&"
import script from "./AddressInfo.vue?vue&type=script&lang=js&"
export * from "./AddressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports